import React, { Component } from "react";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { addFieldConsultant } from "../../actions/consultant";
import { addFieldProject } from "../../actions/project";
import { addFieldProgram } from "../../actions/program";


import Select from "react-select"
import ContainerTranslation from "../partials/ContainerTranslation";

class SelectLabeled extends Component {

  constructor(props){
    super(props)

    this.state = {
      selectedOption : null
    }
  }

  handleChange(selectedOption){
    if (this.props.type === "project") {
      this.props.addFieldProject(selectedOption.value, this.props.parent , this.props.id)
    } 
  else if (this.props.type === "collaborators"){
    this.props.addFieldProgram(selectedOption.value.id, 'collaborators' , this.props.id)
  }else if (this.props.type === "programProject"){
    this.props.addFieldProgram(selectedOption.value.id, 'projects' , this.props.id)
  }
  else {
    this.props.addFieldConsultant(selectedOption.value, this.props.parent , this.props.id); 
  }

    this.setState({ selectedOption });
  }

  render(){

    var classRequired = ""
    if(this.props.isRequired){
      classRequired = "required"
    }
    let options = []
    
    if(this.props.options && (this.props.type === 'collaborators' || this.props.type === 'programProject')){
      options = this.props.options.map((opt)=>{
        return  {value : opt, label : opt.fullname}
      })
    }
    else{
      options = this.props.options.map((opt)=>{
        return  {value : opt, label : opt.label}
      })
    }



    const { selectedOption } = this.state;

    return(
      <div className="input-container">
        { this.props.noLabel ?
          null : <label className={classRequired} style={this.state.labelColor}>
            <ContainerTranslation id={[this.props.section]+"."+[this.props.label]+".title"} tag={"span"}/>
            <ContainerTranslation id={[this.props.section]+"."+[this.props.label]+".sub"} tag={"p"}/>
          </label>
        }
        <Select
          value={selectedOption}
          className={'react-select-container '+classRequired}
          classNamePrefix="react-select"
          isSearchable={true}
          placeholder={this.props.placeholder}
          onChange={this.handleChange.bind(this)}
          options={options}
        />
      </div>
    )
  }
}


const mapStateToProps = state => ({
})

const mapDispatchToProps = dispatch => bindActionCreators({
  addFieldConsultant,
  addFieldProject,
  addFieldProgram
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps, null)(SelectLabeled);
